import { IListItem, IMenuList } from '~/src/dash/types/menuList';

export interface ILivestreamOption {
  key: string;
  text: string;
}

export const livestreamOptions: ILivestreamOption[] = [
  {
    key: '0',
    text: 'All',
  },
  {
    key: '1',
    text: 'Live',
  },
  {
    key: '2',
    text: 'VOD',
  },
  {
    key: '3',
    text: 'DVR',
  },
];

export const getLivestreamMenuList = (): IMenuList => {
  const menuList = {} as IMenuList;

  livestreamOptions.forEach((option) => {
    menuList[option.key] = {
      ID: option.key,
      title: option.text,
      selected: false,
    };
  });

  return menuList;
};

export const getLivestreamOptions = (bidderType: string, publisherID: string): IMenuList => {
  const outputMenuList: IMenuList = {};
  const publishersWithOtherLivestreamOptions = ['381'];

  // always add the general livestream options to the multi-select livestream dropdown
  const generalLivestreamOptions = livestreamOptions.slice(0, 3);
  const otherLivestreamOptions = livestreamOptions.slice(3);

  for (const livestreamOption of generalLivestreamOptions) {
    outputMenuList[livestreamOption.key] = {
      ID: livestreamOption.key,
      title: livestreamOption.text,
      selected: false,
    } as IListItem;
  }

  // for now, only add the other livestream options to the publica - other vast bidder and Philo
  if (bidderType === 'publica' || publishersWithOtherLivestreamOptions.includes(publisherID)) {
    for (const livestreamOption of otherLivestreamOptions) {
      outputMenuList[livestreamOption.key] = {
        ID: livestreamOption.key,
        title: livestreamOption.text,
        selected: false,
      } as IListItem;
    }
  }

  return outputMenuList;
};

export const getSelectedLivestreamOptions = (
  livestreamOptionIDs: string,
  bidderType: string,
  publisherID: string,
): IMenuList => {
  const livestreamOptionsMenuList = getLivestreamOptions(bidderType, publisherID);

  // Remove the 'All' option from the livestream options
  delete livestreamOptionsMenuList['0'];

  // Check if the 'All' option has been selected or none have been selected
  const allOptionsSelected = livestreamOptionIDs && livestreamOptionIDs.split(',').includes('0');

  // If all options selected, toggle the selected value for all livestream options
  if (allOptionsSelected) {
    for (const livestreamOption of Object.values(livestreamOptionsMenuList)) {
      if (livestreamOptionsMenuList[livestreamOption.ID]) {
        livestreamOptionsMenuList[livestreamOption.ID].selected = true;
      }
    }
    return livestreamOptionsMenuList;
  }

  // Else only some options are selected, toggle the selected value for those livestream options
  const selectedLivestreamOptions = (livestreamOptionIDs && livestreamOptionIDs.split(',')) || [];
  for (const selectedLivestreamOption of selectedLivestreamOptions) {
    if (livestreamOptionsMenuList[selectedLivestreamOption]) {
      livestreamOptionsMenuList[selectedLivestreamOption].selected = true;
    }
  }
  return livestreamOptionsMenuList;
};

export const getLivestreamOption = (key: number): ILivestreamOption | undefined => {
  return livestreamOptions.find((opt) => {
    return parseInt(opt.key, 10) === key;
  });
};
